<div class="wrapper">
	<input type="text" [value]="value" [placeholder]="placeholder" (input)="rawFireEvent($event)" #inputElement />
	<app-icon class="search-icon" name="search" size="small" color="primary-2"></app-icon>
</div>
